

function displaySizes(show_size_list, display_type) {
  if (display_type === undefined) {
    display_type = "inline-block";
  }

  let retstr = "";
  if (show_size_list.indexOf("default") !== -1) {
    retstr = "d-" + display_type;
  } else {
    retstr = "d-none";
  }

  let sizes = ["xxs", "xs", "sm", "md", "lg", "xl", "xxl"];
  for (var s in sizes) {
    if (show_size_list.indexOf(sizes[s]) !== -1) {
      retstr += " d-" + sizes[s] + "-" + display_type;
    } else {
      retstr += " d-" + sizes[s] + "-none";
    }
  }
  return retstr;
}



function cssify(text, keep_case, divider) {
  //take text and sanitise it for css/js/urls/whatever
  if (text === undefined) return "";
  if (!(keep_case === true)) {
    text = text.toLowerCase();
  }
  if (divider === undefined) {
    divider = '-';
  }
  return text.replace('é', 'e').replace(/[^a-z0-9]+/ig, divider).replace(/(^[^a-z0-9]|[^a-z0-9]$)/ig, '');
}

function capitalise(str) {
  if (!str){
    return str;
  }
  if (typeof (str) != typeof ("")) {
    return str;
  }
  return str[0].toUpperCase() + str.substring(1);
}


function titleCase(str){
  if (!str){
    return str;
  }
  if (typeof (str) != typeof ("")) {
    return str;
  }
  return str.replace(
    /(^|\w)\S*/g,
    function(txt) {
      return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
    }
    )
}

//seeded random https://stackoverflow.com/questions/521295/seeding-the-random-number-generator-in-javascript
function mulberry32(a) {
  return function () {
    var t = a += 0x6D2B79F5;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^( t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  }
}


function arrayUniqueFilter(value, index, array) {
  return array.indexOf(value) === index;
}

function overwriteObject(object, newData){
  let ohk = 'OVERWRITE_HELPER'
  let keys = Object.keys(object);
  object[ohk] = true;// keep this key around through the clearout, to maintain references
  for (let key in keys){
    delete object[key]
  }
  Object.assign(object, newData)
  delete object[ohk]
}

export { displaySizes, cssify, capitalise, titleCase, mulberry32, arrayUniqueFilter, overwriteObject};
